import { formatDate, formatPower, formatPricePerKWh, formatTime } from '@ste/shared';
import { useLive } from '../../api/live.ts';
import { useGridSessions } from '../../api/queries.ts';
import { Card, EmptyState, PageHeader, Spinner, Stat } from '../../components/ui.tsx';
import { t } from '../../i18n/index.ts';
import { HemsBanner } from './HemsBanner.tsx';
import { PricesCard } from './PricesCard.tsx';

export function GridPage() {
  const live = useLive();
  const events = useGridSessions();
  if (!live) return <Spinner label={t('common.loading')} />;
  const grid = live.grid.power;

  return (
    <div className="space-y-4">
      <PageHeader title={t('grid.title')} />
      <HemsBanner live={live} />
      <Card>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
          <Stat
            label={grid > 0 ? t('flow.import') : t('flow.export')}
            value={formatPower(Math.abs(grid))}
            tone={grid > 30 ? 'warm' : grid < -30 ? 'accent' : 'muted'}
          />
          <Stat
            label={t('grid.tariffGrid')}
            value={live.tariff.grid !== undefined ? formatPricePerKWh(live.tariff.grid) : '–'}
          />
          <Stat
            label={t('grid.tariffFeedIn')}
            value={live.tariff.feedIn !== undefined ? formatPricePerKWh(live.tariff.feedIn) : '–'}
          />
        </div>
      </Card>

      <PricesCard />

      <Card title={t('grid.events')}>
        {events.isLoading && <Spinner label={t('common.loading')} />}
        {events.data && events.data.length === 0 && <EmptyState>{t('grid.noEvents')}</EmptyState>}
        {events.data && events.data.length > 0 && (
          <ul className="divide-y divide-border">
            {events.data.slice(0, 20).map((event) => {
              const start = event.created ? new Date(event.created) : undefined;
              const end = event.finished ? new Date(event.finished) : undefined;
              return (
                <li key={event.id} className="flex items-center justify-between gap-3 py-3">
                  <div>
                    <div className="font-medium">
                      {event.type === 'consumption'
                        ? t('grid.event.consumption')
                        : t('grid.event.production')}
                    </div>
                    <div className="text-sm text-muted">
                      {start && `${formatDate(start)} ${formatTime(start)}`}
                      {end ? ` – ${formatTime(end)}` : ' – läuft'}
                    </div>
                  </div>
                  <div className="text-sm text-muted">
                    {t('grid.limit')} {formatPower(event.limit)}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </Card>
    </div>
  );
}
